export default {"src":"/_next/static/media/express_js_logo_1ad443d385.06e09629.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};